import React, { useRef } from 'react';
import { getIn18Text } from 'api';
import { Dropdown, Menu } from 'antd';
import TaskMailBtn from '../taskMail/TaskMailBtn';
import PraiseMailBtn from '../praiseMail/PraiseMailBtn';
import styles from './btn.module.scss';
import { TongyongGengduo, TongyongJiazai } from '@sirius/icons';
import classnames from 'classnames';
import { ReactComponent as TongyongTianjia } from '@web-common/images/newIcon/tongyong_tianjia.svg';
export const InsertVariableBtn = (props) => {
    const { click } = props;
    return (React.createElement("div", { className: styles.variableArea, onClick: click, "data-test-id": "write-subject-var" },
        React.createElement(TongyongTianjia, null),
        React.createElement("div", { className: styles.variable }, getIn18Text('CHARUBIANLIANG'))));
};
export const AiPolishBtn = (props) => {
    const { loading, onClick, innerRef, dataTestId } = props;
    return (React.createElement("div", { ref: innerRef, "data-test-id": dataTestId, className: classnames(styles.btnWrap, styles.aiPolishBtn, {
            [styles.disabled]: loading,
        }), onClick: onClick },
        React.createElement("div", { className: styles.txt },
            React.createElement("img", { src: require('./AIretouchicon.png'), width: 16 }),
            React.createElement("span", { className: styles.label }, "AI\u6DA6\u8272\u4E3B\u9898")),
        loading ? React.createElement(TongyongJiazai, { className: classnames(styles.icon, styles.loadingIcon, 'sirius-spin'), wrapClassName: styles.iconWrap }) : null));
};
export const BtnDivider = () => {
    return React.createElement("div", { className: styles.dividerWrap });
};
export const SubjectOtherBtn = () => {
    const taskMailBtnRef = useRef(null);
    const praiseMailBtnRef = useRef(null);
    const handleSelectItem = (key) => {
        var _a, _b;
        if (key === 'taskMail') {
            (_a = taskMailBtnRef.current) === null || _a === void 0 ? void 0 : _a.click();
        }
        if (key === 'praiseMail') {
            (_b = praiseMailBtnRef.current) === null || _b === void 0 ? void 0 : _b.click();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { overlay: React.createElement(Menu, { onClick: item => {
                    if (item.key === 'taskMail') {
                        handleSelectItem('taskMail');
                    }
                    else if (item.key === 'praiseMail') {
                        handleSelectItem('praiseMail');
                    }
                } },
                React.createElement(Menu.Item, { key: "taskMail" }, getIn18Text('RENWUYOUJIAN'))) },
            React.createElement("div", { className: styles.otherBtn },
                React.createElement(TongyongGengduo, { className: styles.icon, wrapClassName: styles.iconWrap }))),
        React.createElement(TaskMailBtn, { hidden: true, ref: taskMailBtnRef }),
        React.createElement(PraiseMailBtn, { hidden: true, ref: praiseMailBtnRef })));
};
